const CloseIcon = () => {
    return (
        <svg  width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect width="2.02509" height="19.5614" transform="matrix(0.698129 0.715972 -0.717036 0.697036 14.0264 0.504211)" fill="white"/>
            <rect width="2.02509" height="19.5606" transform="matrix(-0.717036 0.697036 -0.698129 -0.715972 15.376 14.0048)" fill="white"/>
        </svg>
    )
}

export default CloseIcon;